<template>
	<v-row>
		<v-col>
			<v-row no-gutters>
				<v-col align-self="start" cols="4" md="12">
					<span class="font-weight-bold text-body-2 text-md-h6">Name</span>
				</v-col>
				<v-col align-self="start" class="pt-1 text-body-2" cols="8" md="12">
					{{ product.name }}
				</v-col>
			</v-row>
			<v-divider class="my-2"></v-divider>
			<v-row no-gutters>
				<v-col align-self="start" cols="4" md="12">
					<span class="font-weight-bold text-body-2 text-md-h6">Type</span>
				</v-col>
				<v-col align-self="start" class="pt-1 text-body-2" cols="8" md="12">
					{{ helpers.ucFirst(product.template.type) }}
					<v-icon class="mx-2" small>mdi-slash-forward</v-icon>
					{{ product.template.name }}
				</v-col>
			</v-row>
			<v-divider class="my-2"></v-divider>
			<v-row no-gutters>
				<v-col align-self="start" cols="4" md="12">
					<span class="font-weight-bold text-body-2 text-md-h6">Description</span>
				</v-col>
				<v-col align-self="start" class="pt-1 text-body-2" cols="8" md="12">
					<span v-html="product.short_information"></span>
				</v-col>
			</v-row>
			<v-divider class="my-2"></v-divider>
			<v-row no-gutters>
				<v-col align-self="start" cols="4" md="12">
					<span class="font-weight-bold text-body-2 text-md-h6">Restrictions</span>
				</v-col>
				<v-col align-self="start" class="pt-1 text-body-2" cols="8" md="12">
					<span v-if="product.restrictions" v-html="product.restrictions"></span>
					<span v-else>This product has no restrictions.</span>
				</v-col>
			</v-row>
			<v-divider class="my-2"></v-divider>
			<v-row no-gutters>
				<v-col align-self="start" cols="4" md="12">
					<span class="font-weight-bold text-body-2 text-md-h6">Repeat</span>
				</v-col>
				<v-col align-self="start" class="pt-1 text-body-2" cols="8" md="12">
					{{
						product.repeat
								? `This product will repeat every ${product.repeat_delay} ${product.repeat_delay_type}s`
								: 'This product does not repeat.'
					}}
				</v-col>
			</v-row>
			<v-divider class="my-2"></v-divider>

			<!-- Standard Redemption -->
			<div v-if="product.redemptions === 'standard'">
				<v-row no-gutters>
					<v-col align-self="start" cols="4" md="12">
						<span class="font-weight-bold text-body-2 text-md-h6">Redeem Mode</span>
					</v-col>
					<v-col align-self="start" class="pt-1 text-body-2" cols="8" md="12">
						{{ product.redemption_settings.mode }}
					</v-col>
				</v-row>
				<v-divider class="my-2"></v-divider>
				<v-row no-gutters>
					<v-col align-self="start" cols="4" md="12">
						<span
								class="font-weight-bold text-body-2 text-md-h6">Redeem Instructions</span>
					</v-col>
					<v-col align-self="start" class="pt-1 text-body-2" cols="8" md="12">
						<span v-html="product.redemption_settings.instructions"></span>
					</v-col>
				</v-row>
				<v-divider class="my-2"></v-divider>

				<template v-if="product.redemption_settings.mode === 'phone'">
					<v-row no-gutters>
						<v-col align-self="start" cols="4" md="12">
							<span class="font-weight-bold text-body-2 text-md-h6">Redeem Phone</span>
						</v-col>
						<v-col align-self="start" class="pt-1 text-body-2" cols="8" md="12">
							{{ product.redemption_settings.phone_number }}
						</v-col>
					</v-row>
				</template>

				<template v-if="product.redemption_settings.mode === 'online'">
					<v-row no-gutters>
						<v-col align-self="start" cols="4" md="12">
							<span class="font-weight-bold text-body-2 text-md-h6">Redeem Website</span>
						</v-col>
						<v-col align-self="start" class="pt-1 text-body-2" cols="8" md="12">
							<a
									class="text-decoration-none"
									:href="product.redemption_settings.website"
									target="_blank"
							>
								{{ product.redemption_settings.website }}
								<v-icon class="ms-2" small>mdi-open-in-new</v-icon>
							</a>
						</v-col>
					</v-row>
				</template>

			</div>

			<!-- Check-In Redemption -->

			<!-- No Redemption -->

		</v-col>
		<v-col class="mt-8 mt-sm-4 mt-md-0" cols="12" md="auto">
			<v-responsive
					:aspect-ratio="1/2"
					class="grey lighten-4 mx-auto rounded-xl"
					min-width="calc(min(calc(100vw), calc(512px)) - 2rem)"
					max-width="512px"
			>
				<mobile-pass-preview :preview-url="previewUrl"></mobile-pass-preview>
			</v-responsive>
		</v-col>
	</v-row>
</template>

<script>
import { helpers } from '../../../../Shared/helpers';

export default {
	name: 'ViewProduct',
	props: {
		previewUrl: {
			type: String,
			default: null
		},
		// The incoming product from an edit
		product: {
			type: Object,
			default: () => ({})
		},
		partner: {
			type: Object | null,
			default: null
		},
		returnUrl: {
			type: String,
			default: ''
		},
		venue: {
			type: Object,
			default: () => ({})
		}
	},
	data() {
		return {
			helpers
		}
	},
	mounted() {
	},
	computed: {},
	methods: {}
};
</script>

<style lang="scss"></style>
